module.exports = __webpack_public_path__ + "static/img/banner-text-old.b5c6797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-text-old.png
// module id = mTYG
// module chunks = 1